import { ConfirmDialog, confirmDialog } from "primereact/confirmdialog";
import MeaPage from "../../../components/MeaPage";
import DocumentsListComponent from "./components/DocumentsListComponent";
import { useRef } from "react";
import documentsAPI from "../../../services/documents";
import { Toast } from "primereact/toast";
import { useParams } from "react-router-dom";

const DocumentsListPage = () => {
  //


  const params = useParams();
  const schoolId = params.schoolId
  const trainingId = params.trainingId;
  const accessToken = "";

  const listRef = useRef();
  const toast = useRef();
  //
  return (
    <>
      <MeaPage
        //breadcrumb={<SlotsBreadCrumb />}
        title="Liste des documents"
        subtitle="Consulter l'ensemble des documents de cette formation"
        actions={[
          {
            label: "Générer les dossiers de la formation",
            icon: "pi pi-folder-open",
            command: () => {
              confirmDialog({
                message: "Voulez-vous vraiment générer les dossiers par défaut de cette formation?",
                header: "Confirmation",
                icon: "pi pi-info-circle",
                defaultFocus: "reject",
                acceptClassName: "p-button-danger",
                accept: () => {
                  documentsAPI
                    .GenerateTrainingFolders(schoolId, trainingId, accessToken)
                    .then((data) => {
                      //reloadCurrentTraining();
                      listRef.current.refresh();
                      toast.current.show({
                        severity: "success",
                        summary: "Succès",
                        detail: "Générés!",
                        life: 3000,
                      });
                    });
                }
              })
            }
          }
        ]}
      >
        <ConfirmDialog />
        <Toast ref={toast} />
        <DocumentsListComponent
          ref={listRef}
          showAddButton={true}
          showFilterButton={true}
        />
      </MeaPage>
    </>
  );
};
export default DocumentsListPage;
